import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { FastField, Field, useFormikContext } from "formik";
import { TextField } from "@mui/material";
import DropdownSelector from "../../atoms/Common/DropdownSelector.tsx";
import { getCatalogue } from "../../api/common/catalogues.ts";
import { LGNumber } from "../../atoms/Inputs/LGNumber.tsx";

export default function ProductCartonForm() {
  const { values, setFieldValue } = useFormikContext() as any;

  // Initialize props structure for CARTON products (ancho, largo, espesor, especificación)
  useEffect(() => {
    if (
      !values.props ||
      values.props.length === 0 ||
      !values.props.some(
        (p: any) => p?.key === "A" || p?.key === "L" || p?.key === "E" || p?.key === "U" || p?.key === "S"
      )
    ) {
      const props = [
        { key: "A", value: "" }, // Ancho
        { key: "L", value: "" }, // Largo
        { key: "E", value: "" }, // Espesor
        { key: "U", value: "" }, // Unidad de medida
        { key: "S", value: "" }, // Especificación
      ];
      setFieldValue("props", props);
    }
  }, [setFieldValue, values.props]);

  useEffect(() => {
    const concatenatedValue = `${values.thickness || ""}${values.thickness_unit?.toUpperCase() || ""}`;
    setFieldValue("props.2.value", concatenatedValue);
  }, [values.thickness, values.thickness_unit, setFieldValue]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.0.value"
          label="Ancho (cm)"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.1.value"
          label="Largo (cm)"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
        />
      </Grid>

      <Grid item xs={6}>
        <Field
          fullWidth
          name="thickness"
          label="Espesor"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
          onChange={(e) => {
            setFieldValue("thickness", e.target.value);
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <FastField
          fullWidth
          name="thickness_unit"
          label="Unidad de Espesor"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT", pageSize: 1000 }}
          keyField="code"
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.3.value"
          label="Unidad de medida"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT", pageSize: 1000 }}
          keyField="id"
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.4.value"
          label="Especificación"
          as={TextField}
        />
      </Grid>
    </Grid>
  );
}
